import React from "react";
import { useNavigate } from "react-router-dom";
import { objToFormData } from "src/helpers/FormHelper";
import { createPost } from "src/actions/community/postsActions";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { setNewError, setNewParams } from "src/store/community/postsSlice";

import Form from './_partials/_Form';
import DrawerRight from "src/componets/DrawerRight";
import AlertBlock from "src/componets/AlertBlock";

const New = () => {
  const navigate = useNavigate();
  const dispatch  = useAppDispatch();
  const newParams = useAppSelector(state => state.community.posts.newParams);
  const error = useAppSelector(state => state.community.posts.newError);

  let params = newParams;

  function onCloseError() {
    dispatch(setNewError(null));
  }

  function onClose() {
    dispatch(setNewParams(null));
  }

  function onFinish(rawData: any) {
    const data = { ...rawData };
    delete data.moment_date;

    data.published_at = rawData.moment_date.toString();

    const formData = objToFormData(data);
    handleSave(formData).catch(console.error);
  }

  async function handleSave(data: object) {
    const resultAction = await dispatch(createPost(data));

    if (createPost.fulfilled.match(resultAction)) {
      onClose();
      navigate(0);
    }
  }

  return (
    <DrawerRight
      open={!!params}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-new-post'>
        <h6 className="v-content-label">Create Post</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        <Form onFinish={onFinish} params={params} />
      </div>
    </DrawerRight>
  )
}

export default New;
